module.exports = __webpack_public_path__ + "static/media/no_sig.0e5856e7.svg";